import { Award, SocialLinks } from '../types';

export const social: SocialLinks = {
    github: 'https://github.com/tony3898',
    linkedin: 'https://linkedin.com/in/tejasrana3898',
    twitter: 'https://twitter.com/tejasrana3898',
    instagram: 'https://instagram.com/tejasrana3898'
};

export const awards: Award[] = [
    {
        title: 'Freespace Diver Award',
        description: 'Recognized for innovative thinking and creative problem-solving',
        year: '2024'
    },
    {
        title: 'Monday Crusher MVP',
        description: 'Outstanding team performance and exceptional contribution',
        year: '2024'
    }
];

export const adjectives: string[] = [
    '🏗️ Aspiring Solution Architect',
    '🚀 Cloud Practitioner',
    '🎮 Casual Gamer',
    '🎧 Music Lover',
    '💻 Passionate Coder && Tech Doodler',
];

export const references: any[] = []; 